import React, { createContext, useState, useMemo } from 'react';

export const ConnectedUserContext = createContext({
  connectedUser: null,
  setConnectedUser: () => {},
  refreshConnectedUser: () => {},
});

export function buildCtxValue(connectedUser, setConnectedUser, refreshConnectedUser) {
  return { connectedUser, setConnectedUser, refreshConnectedUser };
}

export function ConnectedUserProvider({ children }) {
  const [connectedUser, setConnectedUser] = useState(null);
  const [refreshFn, setRefreshFn] = useState(() => () => {});

  const value = useMemo(
    () => buildCtxValue(connectedUser, setConnectedUser, refreshFn),
    [connectedUser, refreshFn]
  );

  return (
    <ConnectedUserContext.Provider value={value}>
      {children}
    </ConnectedUserContext.Provider>
  );
}